/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Issues_DInputs */

const en_mk_nav_p_issues_d = /** @type {(inputs: Mk_Nav_P_Issues_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List, board and table in one place.`)
};

const id_mk_nav_p_issues_d = /** @type {(inputs: Mk_Nav_P_Issues_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar, papan, dan tabel dalam satu tempat.`)
};

/**
* | output |
* | --- |
* | "List, board and table in one place." |
*
* @param {Mk_Nav_P_Issues_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_issues_d = /** @type {((inputs?: Mk_Nav_P_Issues_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Issues_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_issues_d(inputs)
	return en_mk_nav_p_issues_d(inputs)
});